import * as React from 'react';
import axios from "axios";
import { useState, useEffect, useContext } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { AuthContext } from "../context/AuthContext";
import { CloudContext } from "../context/CloudContext";
import { useTranslation } from "react-i18next";
import config from '../config.js';
import Stack from '@mui/material/Stack';
import Backdrop from '@mui/material/Backdrop';
import { SvgIcon } from '@mui/material';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import { uploadS3Presigned, fileExistsInS3 } from "../utils/interfaceS3";
import { uploadToCesiumS3, uploadObjBundleToCesiumS3 } from "../utils/cesiumManagement";
import AddIcon from '@mui/icons-material/Add';
import UploadIcon from '@mui/icons-material/Upload';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AttachmentIcon from '@mui/icons-material/Attachment';
import CircularProgress from '@mui/material/CircularProgress';
import ImageIcon from '@mui/icons-material/Image';
import { FileUploader } from "react-drag-drop-files";
import { useSnackbar } from 'notistack';
import ProductRowAdmin from "../components/ProductRowAdmin.jsx"
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import { alpha } from '@mui/material/styles';

import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from '@mui/material';

export default function ProductsDialogAdmin({ setOpen, open, id, userid }) {

    const { t } = useTranslation();

    const { jwt, idToken } = useContext(AuthContext);
    const { cesium_token,region, idpool, cloudinary_preset, cloudinary_cloud } = useContext(CloudContext);
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [products, setProducts] = useState([]);
    const [addMode, setAddMode] = useState(false);

    //fetch the products corresponding to this id
    useEffect(() => {
        loadProducts();
        // eslint-disable-next-line
    }, [id]);

    function loadProducts() {
        setLoading(true);
        axios.get(`${config.apiUrl}/api/datas/${id}?populate=*`, {
            headers: {
                Authorization:
                    `Bearer ${jwt}`,
            }
        }).then((response) => {
            //console.log(response.data.data.attributes.results.data);
            setLoading(false);
            setProducts(response.data.data.attributes.results.data);
            setAddMode(false);
        }).catch((error) => {
            console.log(error);
            setLoading(false);
            setAddMode(false);
        });
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleAddProductClick = () => {
        setAddMode(true);
    };

    const handleCancel = () => {
        setAddMode(false);
    };

    function clearFields()
    {
        setFileSelected(null);
        setMaterialFiles([]);
        setDescription("");
        setImageSelected("");
        setCesiumIonUpload(false);
        setLongitude("");
        setLatitude("");
        setHeight("");
    }

    const [fileSelected, setFileSelected] = useState(null);
    const [materialFiles, setMaterialFiles] = useState([]);
    const [description, setDescription] = useState("");
    const [cesiumIonUpload, setCesiumIonUpload] = useState(false);
    const [longitude, setLongitude] = useState("");
    const [latitude, setLatitude] = useState("");
    const [height, setHeight] = useState("");

    const materialExtensions = ['.mtl', '.jpg', '.jpeg', '.png'];
    const normalizeFiles = (files) => {
        if (!files) {
            return [];
        }
        const isFileList = typeof FileList !== 'undefined' && files instanceof FileList;
        if (Array.isArray(files)) {
            return files;
        }
        if (isFileList) {
            return Array.from(files);
        }
        return [files];
    };
    const isObjFile = (file) => file?.name?.toLowerCase().endsWith('.obj');
    const isMaterialFile = (file) => {
        const name = file?.name?.toLowerCase() || '';
        return materialExtensions.some((ext) => name.endsWith(ext));
    };
    const handleChange = (files) => {
        const selectedFiles = normalizeFiles(files);
        if (!selectedFiles.length) {
            setFileSelected(null);
            setMaterialFiles([]);
            return;
        }

        const objFiles = selectedFiles.filter(isObjFile);
        if (objFiles.length > 0) {
            if (objFiles.length > 1) {
                enqueueSnackbar(`${t("ErrorObjMultiple")}`, { variant: 'warning' });
                setFileSelected(null);
                setMaterialFiles([]);
                return;
            }
            const materialSelection = selectedFiles.filter(isMaterialFile);
            const otherFiles = selectedFiles.filter((file) => !isObjFile(file) && !isMaterialFile(file));
            if (otherFiles.length > 0) {
                enqueueSnackbar(`${t("ErrorObjBundleTypes")}`, { variant: 'warning' });
                setFileSelected(null);
                setMaterialFiles([]);
                return;
            }
            setFileSelected(objFiles[0]);
            setMaterialFiles(materialSelection);
            return;
        }

        if (selectedFiles.length > 1) {
            enqueueSnackbar(`${t("ErrorMultipleFiles")}`, { variant: 'warning' });
            setFileSelected(null);
            setMaterialFiles([]);
            return;
        }
        setFileSelected(selectedFiles[0]);
        setMaterialFiles([]);
    };

    const [imageSelected, setImageSelected] = React.useState("");
    const imageTypes = ["PNG", "png", "JPG", "jpg", "JPEG", "jpeg"];
    const handleImageChange = (file) => {
        setImageSelected(file);
    };

    const uploadImage = async (imageSelected) => {
        const formData = new FormData();
        formData.append("file", imageSelected);
        formData.append("upload_preset", cloudinary_preset);

        const response = await axios.post(`https://api.cloudinary.com/v1_1/${cloudinary_cloud}/image/upload`, formData);
        return response.data.secure_url;
    };

    function hasWhiteSpace(s) {
        return s.indexOf(' ') >= 0;
    }

    const handleUploadProductClick = () => {
        setLoading(true);
        //check if file has been selected
        if (typeof fileSelected?.name == 'string') {

            // Check if Cesium ION upload is checked and coordinates are required but missing
            if (cesiumIonUpload && fileSelected.name.toLowerCase().endsWith('.obj')) {
                console.log(longitude)
                console.log(latitude)
                console.log(height)
                if (!longitude || !latitude || !height) {
                    enqueueSnackbar(t("ErrorCoordinatesRequired"), { variant: 'warning' });
                    setLoading(false);
                    return;
                }
            }

            const filesToValidate = [fileSelected, ...materialFiles].filter(Boolean);
            const hasSpaceInName = filesToValidate.some((file) => hasWhiteSpace(file.name));
            //check if the filename contains ' '
            if (hasSpaceInName) {
                enqueueSnackbar(`${t("ErrorFileNoSpace")}`, { variant: 'warning' });
                setLoading(false);
            } else {
                //check if file exists   
                fileExistsInS3(userid, idToken, fileSelected.name).then(res => {
                    //console.log(res);
                    if (!res) {
                        console.log(fileSelected)
                        newProduct(userid, fileSelected, description, materialFiles);
                    } else {
                        enqueueSnackbar(`${t("ErrorAlreadyExists")}`, { variant: 'warning' });
                        setLoading(false);
                    }
                })
            }
        } else {
            enqueueSnackbar(`${t("ErrorNoFile")}`, { variant: 'warning' });
            setLoading(false);
        }
    };

    async function newProduct(userid, file, description, materials = []) {

        let optimizeImage = null;

        if (typeof imageSelected.name === 'string') {
            optimizeImage = await uploadImage(imageSelected);
        }

        let cesiumId = null;
        const filename = file?.name || '';
        const lowerFilename = filename.toLowerCase();

        // Check if Cesium ION upload is requested for OBJ files
        if (cesiumIonUpload && (lowerFilename.endsWith('.obj')||lowerFilename.endsWith('.geojson')) && cesium_token) {
            try {
                // Prepare coordinates array if all values are provided
                const coordinates = (longitude && latitude && height) 
                    ? [longitude, latitude, height] 
                    : null;
                if(lowerFilename.endsWith('.obj')){
                    cesiumId = await uploadObjBundleToCesiumS3(filename, description, file, materials, cesium_token, () => {}, coordinates);
                }
                if(lowerFilename.endsWith('.geojson')){
                    cesiumId = await uploadToCesiumS3(filename, description, file, cesium_token, () => {}, 'GEOJSON');
                }
                
            } catch (error) {
                console.error('Error uploading to Cesium ION:', error);
                enqueueSnackbar(`${t("ErrorUpload")} (Cesium ION)`, { variant: 'error' });
                setLoading(false);
                clearFields();
                return;
            }
        }

        console.log("uploadToCesiumS3 done")

        uploadS3Presigned(userid, idToken, region, idpool, filename, file).then(res => {
            const dataForm = new FormData();
            const formData = {
                filename: `${config.dirs.products}/` + filename,
                description: description,
                imageUrl: optimizeImage
            };

            // Add Cesium ID if upload was successful
            if (cesiumId) {
                formData.id_cesium = cesiumId;
            }

            dataForm.append('data', JSON.stringify(formData))
            axios.post(`${config.apiUrl}/api/results`, dataForm, {
                headers: {
                    Authorization: `Bearer ${jwt}`,
                }
            })
                .then(res => {
                    updateDataWithNewProduct(id, res.data.data.id);
                })
                .catch(err => {
                    console.log(err);
                    setLoading(false);
                    clearFields();
                    enqueueSnackbar(`${t("ErrorUpload")}`, { variant: 'error' });
                });
        })
    }

    async function updateDataWithNewProduct(idData, idProduct) {

        let data = await axios.get(`${config.apiUrl}/api/datas/${idData}?populate=*`, {
            headers: {
                Authorization:
                    `Bearer ${jwt}`,
            },
        });
        //console.log(data);
        //Add the id to the previous list of ids
        let newDataIds = [];
        let listFiles = data.data.data.attributes.results.data;
        for (let i = 0; i < listFiles.length; i += 1) {
            newDataIds.push(listFiles[i].id);
        }
        newDataIds.push(idProduct);
        //console.log(newDataIds);
        const dataForm = new FormData();
        dataForm.append('data', JSON.stringify({
            results: newDataIds,
        }))
        await axios.put(`${config.apiUrl}/api/datas/${idData}`, dataForm, {
            headers: {
                'Authorization': `Bearer ${jwt}`,
                'Content-Type': 'multipart/form-data'
            }
        });
        enqueueSnackbar(`${t("UploadSuccess")}`, { variant: 'success' });
        clearFields();
        loadProducts();
    }

    return (

        <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth={true}>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={loading}
            >
                <Grid
                    container
                    sx={{ alignItems: 'center', justifyContent: 'center', alignContent: 'center' }}
                >
                    <Stack
                        sx={{
                        justifyContent: "flex-start",
                        alignItems: "center",
                        }}
                        direction="row"
                        spacing={2}
                    >
                        <CircularProgress color="inherit" size="5rem" />
                        <Typography variant="h5" color="inherit">
                            <b>{t("UploadingContent")}</b>
                        </Typography>
                     </Stack>
                </Grid>
            </Backdrop>
            <Box sx={{ p: 2 }}>
                <DialogTitle>
                    <Typography variant="h4" component={"div"}>
                        {t("Products")}
                    </Typography>
                </DialogTitle>
                <DialogContent>


                    <Grid container spacing={2} sx={{ paddingTop: 2 }}>
                        {products.length > 0 ?
                            <>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ width: 100 }}>
                                                {t("File")}
                                            </TableCell>
                                            <TableCell>
                                                {t("Description")}
                                            </TableCell>
                                            <TableCell sx={{ width: 80 }}>
                                                {t("Date")}
                                            </TableCell>
                                            <TableCell align="right" sx={{ width: 40 }}>

                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {products.map((product, index) => (
                                            <ProductRowAdmin key={index} data={product} id={index} userid={userid} loadProducts={loadProducts} />
                                        ))}
                                    </TableBody>
                                </Table>
                            </>
                            :
                            <Typography color="text.secondary" variant="body2">{t("NoProductAdmin")}</Typography>
                        }
                    </Grid>
                    {addMode &&
                        <Stack spacing={3} sx={{ mt: 5 }}>
                            {/* <Typography color="text.primary" variant="h6">{t("AddNewProductAdmin")}</Typography> */}
                            <Stack spacing={1}>
                                <Typography
                                    color="text.secondary"
                                    variant="h6"
                                >
                                    {t("AddNewProductAdmin")}
                                </Typography>
                            <FileUploader
                                handleChange={handleChange}
                                multiple
                                name="file"
                                hoverTitle=" "
                                children={
                                    <Box>
                                        <Paper variant="outlined"
                                            sx={{
                                                borderColor: '#E5E7EB',
                                                borderStyle: 'solid',
                                                borderWidth: 1,
                                                '&:hover': {
                                                    backgroundColor: alpha('#111927', 0.04)
                                                }
                                            }}>
                                            <Grid
                                                container
                                                direction="row"
                                                style={{ minHeight: '100px', padding: 20 }}
                                                sx={{ alignItems: 'center', justifyContent: 'center' }}
                                            >

                                                <Stack
                                                    direction="row"
                                                    spacing={2}
                                                    sx={{ alignItems: 'center' }}
                                                >
                                                    <CloudUploadIcon style={{ color: 'gray' }} /><Typography variant="body2" color="text.secondary">{t("dragndrop")}</Typography>
                                                </Stack>
                                            </Grid>
                                        </Paper>
                                    </Box>}
                            />
                            </Stack>
                            {fileSelected &&
                            <Stack
                                direction="row"
                                spacing={1}
                                sx={{ alignItems: 'center' }}
                            >
                                <AttachmentIcon style={{ color: 'gray' }} />
                                <Typography variant="body2" color="text.secondary"><b>{fileSelected.name}</b></Typography>
                            </Stack>}
                            {fileSelected && isObjFile(fileSelected) && materialFiles.length > 0 &&
                            <Stack spacing={0.5}>
                                <Typography variant="body2" color="text.secondary">{t("Materials")}</Typography>
                                {materialFiles.map((file, index) => (
                                    <Stack
                                        key={`${file.name}-${file.lastModified ?? index}`}
                                        direction="row"
                                        spacing={1}
                                        sx={{ alignItems: 'center' }}
                                    >
                                        <AttachmentIcon style={{ color: 'gray' }} />
                                        <Typography variant="body2" color="text.secondary"><b>{file.name}</b></Typography>
                                    </Stack>
                                ))}
                            </Stack>}
                            {fileSelected && fileSelected.name && (fileSelected.name.toLowerCase().endsWith('.obj')||fileSelected.name.toLowerCase().endsWith('.geojson')) &&
                            <Stack spacing={1}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={cesiumIonUpload}
                                                onChange={(event) => setCesiumIonUpload(event.target.checked)}
                                                name="cesium-ion-upload"
                                            />
                                        }
                                        label={t("UploadToCesiumION")}
                                        sx={{ flexShrink: 0 }}
                                    />
                                    {(cesiumIonUpload && fileSelected.name.toLowerCase().endsWith('.obj')) && (
                                        <>
                                            <TextField
                                                label={t("Longitude")}
                                                value={longitude}
                                                onChange={(event) => setLongitude(event.target.value)}
                                                size="small"
                                                sx={{ flex: 1 }}
                                                type="number"
                                                slotProps={{ 
                                                    htmlInput: { step: "any" }
                                                }}
                                            />
                                            <TextField
                                                label={t("Latitude")}
                                                value={latitude}
                                                onChange={(event) => setLatitude(event.target.value)}
                                                size="small"
                                                sx={{ flex: 1 }}
                                                type="number"
                                                slotProps={{ 
                                                    htmlInput: { step: "any" }
                                                }}
                                            />
                                            <TextField
                                                label={t("Height")}
                                                value={height}
                                                onChange={(event) => setHeight(event.target.value)}
                                                size="small"
                                                sx={{ flex: 1 }}
                                                type="number"
                                                slotProps={{ 
                                                    htmlInput: { step: "any" }
                                                }}
                                            />
                                        </>
                                    )}
                                </Box>
                            </Stack>}
                            <Stack spacing={1}>
                            <Typography
                            color="text.secondary"
                            variant="h6"
                            >
                                {t("Description")}
                            </Typography>
                            <TextField
                                fullWidth
                                name="description"
                                type="text"
                                multiline
                                rows={3}
                                value={description}
                                onChange={(event) => { setDescription(event.target.value) }}
                            />
                            </Stack>
                            <Stack spacing={1}>
                                <Typography
                                color="text.secondary"
                                variant="h6"
                                >
                                    {t("Image")}
                                </Typography>
                                <FileUploader
                                    handleChange={handleImageChange}
                                    multiple={false}
                                    name="image"
                                    types={imageTypes}
                                    hoverTitle=" "
                                    maxSize={10}
                                    children={
                                        <Box>
                                            <Paper variant="outlined"
                                                sx={{
                                                    borderColor: '#E5E7EB',
                                                    borderStyle: 'solid',
                                                    borderWidth: 1,
                                                    '&:hover': {
                                                        backgroundColor: alpha('#111927', 0.04)
                                                    }
                                                }}>
                                                <Grid
                                                    container
                                                    direction="row"
                                                    style={{ minHeight: '100px', padding: 20 }}
                                                    sx={{ alignItems: 'center', justifyContent: 'center' }}
                                                >

                                                    <Stack
                                                        direction="row"
                                                        spacing={2}
                                                        sx={{ alignItems: 'center' }}
                                                    >
                                                        <ImageIcon style={{ color: 'gray' }} /><Typography variant="body2" color="text.secondary">{t("dragndrop")}</Typography>
                                                    </Stack>
                                                </Grid>
                                            </Paper>
                                        </Box>}
                                />
                                {imageSelected &&
                                    <Stack
                                        direction="row"
                                        spacing={1}
                                        sx={{ alignItems: 'center' }}
                                    >
                                        <AttachmentIcon style={{ color: 'gray' }} />
                                        <Typography variant="body2" color="text.secondary"><b>{imageSelected.name}</b></Typography>
                                    </Stack>}
                            </Stack> 
                        </Stack>
                    }
                </DialogContent>
                <DialogActions>
                    {!addMode ?
                        <>
                            <Button onClick={handleClose}>{t("Close")}</Button>
                            <Button
                                variant="contained"
                                startIcon={(
                                    <SvgIcon fontSize="medium">
                                        <AddIcon />
                                    </SvgIcon>
                                )}
                                onClick={handleAddProductClick}
                            >
                                {t("UploadProduct")}
                            </Button>
                        </> :
                        <>
                            <Button onClick={handleCancel}>{t("Cancel")}</Button>
                            <Button
                                variant="contained"
                                startIcon={(
                                    <SvgIcon fontSize="medium">
                                        <UploadIcon />
                                    </SvgIcon>
                                )}
                                onClick={handleUploadProductClick}
                            >
                                {t("Upload")}
                            </Button>
                        </>
                    }
                </DialogActions>
            </Box>
        </Dialog>
    );
}
